<template>
    <div
        class="flex items-center justify-between p-4 cursor-pointer"
        @click="openDetails"
    >
        <div class="flex">
            <UIIcon
                :icon="filter.icon"
                weight="regular"
                :size="24"
                class="mr-4 text-(--color-brand-700)"
            />
            <div>
                <div class="flex font-medium">
                    {{ filter.title }}
                </div>
                <div
                    v-if="modelValue?.selected?.length"
                    class="text-neutral-extra-subtle text-sm mr-3"
                >
                    {{ modelValue.selected.length }} selected
                </div>
            </div>
        </div>
        <PhIcon
            icon="caret-right"
            class="text-neutral-extra-strong"
            :size="20"
            weight="regular"
        />
    </div>
</template>
<script setup>
    import { markRaw } from 'vue'
    import PhIcon from '@/components/app/PhIcon.vue'
    import FilterSelectDetails
        from '@/components/next-gen/widget-pages/shared/filters/FilterSelectDetails.vue'
    import UIIcon from '@/components/ui/UIIcon.vue'

    const emit = defineEmits(['update:modelValue', 'openDetails'])

    const props = defineProps({
        filter: Object,
        modelValue: Object,
    })

    const openDetails = () => {
        emit('openDetails', {
            filter: props.filter,
            component: markRaw(FilterSelectDetails),
            props: {},
        })
    }
</script>
